export default {
	// Config
	apiKey: "AIzaSyALKBCrf3gRKxIgZLyej2bI_KdcOmhirXE",
  authDomain: "dabdaddy-mytrace.firebaseapp.com",
  projectId: "dabdaddy-mytrace",
  storageBucket: "dabdaddy-mytrace.firebasestorage.app",
  messagingSenderId: "42395098008",
  appId: "1:42395098008:web:ae90f19e909ae4e385a9ed"
};
